import { render, staticRenderFns } from "./DashboardMural.vue?vue&type=template&id=06dd6016&scoped=true&"
import script from "./DashboardMural.vue?vue&type=script&lang=js&"
export * from "./DashboardMural.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMural.vue?vue&type=style&index=0&id=06dd6016&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dd6016",
  null
  
)

export default component.exports